import React from 'react';
import PropTypes from 'prop-types';

const BoxHeader = (props) => {
  const {title, children} = props;
  return (
      <div className="box-header">
        {title ? <h3 className="box-title">{title}</h3> : ''}

        {children}
      </div>
  );
};

BoxHeader.propTypes = {
  title: PropTypes.string
};

export default BoxHeader;





// WEBPACK FOOTER //
// ./src/component/Box/BoxHeader.js